import { Menu } from 'components/Inputs/Select/customize';

export const RelatedMenu = (props) => {
  return <Menu {...props} zIndexAdjust="4" />;
};
